// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__16iu0","bigColWidth":"Table_bigColWidth__BbYHz","biggerColWidth":"Table_biggerColWidth__2Zhp_","row":"Table_row__1XJ_3","col":"Table_col__QlV_m"};